/** ComfortToggle — a single accessible on/off switch for the larger-text comfort mode (GUIDE-09).
 *
 * Mirrors the ThemeSwitcher/LanguageSwitcher control style (a `lang-switch__btn`) so it sits
 * naturally beside them. It's a labelled toggle: `aria-pressed` reflects the state and the i18n
 * `comfort.toggle` label names it for screen readers. Off by default; the choice persists via
 * `useComfort` (localStorage + `<html data-comfort>`).
 */
import { useTranslation } from "react-i18next";
import { useComfort } from "../theme/useComfort";

export function ComfortToggle() {
  const { t } = useTranslation();
  const { comfort, toggle } = useComfort();
  const label = t("comfort.toggle");

  return (
    <div className="lang-switch comfort-switch" role="group" aria-label={label}>
      <button
        type="button"
        className={`lang-switch__btn comfort-switch__btn ${comfort ? "lang-switch__btn--active" : ""}`.trim()}
        aria-pressed={comfort}
        aria-label={label}
        title={label}
        onClick={toggle}
      >
        <span aria-hidden="true" className="comfort-switch__glyph">
          A
        </span>
        <span>{t(comfort ? "comfort.on" : "comfort.off")}</span>
      </button>
    </div>
  );
}
